/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ConversationThreadContainer_story = {
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_story" | "LocalReplyListContainer_story" | "UserTagsContainer_story">;
    readonly " $refType": "ConversationThreadContainer_story";
};
export type ConversationThreadContainer_story$data = ConversationThreadContainer_story;
export type ConversationThreadContainer_story$key = {
    readonly " $data"?: ConversationThreadContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"ConversationThreadContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConversationThreadContainer_story",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_story"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LocalReplyListContainer_story"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserTagsContainer_story"
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = 'a8cc0e3f5f80d7e8bd64cddc7776ddf3';
export default node;
